module.exports = __webpack_public_path__ + "img/rpa12.aa0abf99.png";